import styled from 'styled-components';

export const ButtonActionRow = styled.button<{$colors?: string, $borderColors?: string}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border: 2px solid  ${({ $borderColors }) => $borderColors};
  padding: 0.25rem 1rem;
  font-weight: 500;
  color: ${({ $colors }) => $colors};
  `;
